var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgResumeRejected = function SvgResumeRejected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "resume-rejected_svg__Resume-reject"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#resume-rejected_svg__a)",
    fillOpacity: 0.8,
    d: "M67.367 6.154H9.23v76.26h58.136z",
    className: "resume-rejected_svg__back"
  }), /*#__PURE__*/React.createElement("g", {
    className: "resume-rejected_svg__Vector",
    filter: "url(#resume-rejected_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#resume-rejected_svg__c)",
    fillOpacity: 0.6,
    d: "M80.98 18H28.445a2.8 2.8 0 0 0-2.8 2.8v70.66a2.8 2.8 0 0 0 2.8 2.8H80.98a2.8 2.8 0 0 0 2.8-2.801V20.801A2.8 2.8 0 0 0 80.98 18"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.3,
    d: "M41.377 35.65H68.05M41.377 49.303H68.05M41.377 62.959H68.05M41.377 76.613H68.05",
    className: "resume-rejected_svg__Vector"
  }), /*#__PURE__*/React.createElement("g", {
    className: "resume-rejected_svg__warn"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.286 73.36h4.252v11.693h-4.252z",
    className: "resume-rejected_svg__Rectangle resume-rejected_svg__4926"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#resume-rejected_svg__d)",
    fillRule: "evenodd",
    d: "M76.65 69.112c1.227-2.127 4.297-2.127 5.524 0l7.818 13.55c1.226 2.127-.308 4.783-2.763 4.783H71.594c-2.454 0-3.989-2.656-2.762-4.782l7.817-13.551Zm2.762 5.577c.44 0 .797.357.797.798v3.986a.797.797 0 1 1-1.594 0v-3.986c0-.44.357-.798.797-.798m0 8.77a.797.797 0 1 0 0-1.594.797.797 0 0 0 0 1.594",
    className: "resume-rejected_svg__Subtract",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "resume-rejected_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    className: "resume-rejected_svg__a",
    gradientTransform: "matrix(38.36962 -31.25783 31.83082 39.07297 36.002 60.822)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B7AFF",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D5FF",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "resume-rejected_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    className: "resume-rejected_svg__c",
    gradientTransform: "rotate(-22.957 145.82 -73.382)scale(70.6457 168.074)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DFE2FF",
    stopOpacity: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B7AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resume-rejected_svg__d",
    x1: 71.663,
    x2: 81.4,
    y1: 68.22,
    y2: 89.534,
    className: "resume-rejected_svg__d",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4407B"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "resume-rejected_svg__b",
    width: 91.743,
    height: 109.867,
    x: 8.841,
    y: 1.196,
    className: "resume-rejected_svg__b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 8.402
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_33943_49089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_33943_49089",
    result: "shape"
  })))));
};
export default SvgResumeRejected;